<template>
  <campaigns />
</template>

<script>
import Campaigns from '@/components/Affiliates/Campaigns/Campaigns'

export default {
  name: 'AffiliatesCampaigns',
  components: {
    Campaigns
  }
}
</script>
